import { render, staticRenderFns } from "./LawNormFormByLaws.vue?vue&type=template&id=6b5c83bd&"
import script from "./LawNormFormByLaws.vue?vue&type=script&lang=js&"
export * from "./LawNormFormByLaws.vue?vue&type=script&lang=js&"
import style0 from "./LawNormFormByLaws.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports